export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
          <div className="w-full lg:w-[38%]">
            <div className="rounded-[32px] overflow-hidden aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20office%20with%20warm%20ambient%20lighting%2C%20creative%20team%20collaboration%20atmosphere%2C%20digital%20screens%20displaying%20entertainment%20news%2C%20coral%20and%20gold%20warm%20tone%2C%20professional%20media%20company%20aesthetic%2C%20clean%20minimal%20composition&width=760&height=950&seq=about-brand-image&orientation=portrait"
                alt="51吃瓜网品牌形象"
                title="51吃瓜网 吃瓜爆料第一站"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full lg:w-[62%]">
            <span className="inline-block text-xs font-label tracking-wider text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
              关于我们
            </span>
            <h2 className="font-heading text-[32px] md:text-[42px] text-foreground-950 leading-tight mb-6">
              51吃瓜网
              <br />
              吃瓜爆料第一站
              <br />
              全网最快最全的吃瓜平台
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              51吃瓜网成立于2023年，是国内领先的娱乐八卦与热门事件资讯聚合平台。我们以"吃瓜爆料第一站"为定位，致力于为全网吃瓜群众提供最快、最全、最真实的娱乐资讯和热点追踪服务。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8">
              平台汇聚了明星动态、网红事件、综艺争议、影视剧透、黑料网曝等全品类娱乐内容，覆盖国内主流社交媒体平台的热门话题。我们的编辑团队7×24小时不间断监控全网热点，确保每一位用户都能在第一时间获取最新、最热的瓜情资讯。
            </p>
            <div className="flex items-center gap-8">
              <div className="text-center">
                <div className="text-[28px] font-heading text-primary-600">2年+</div>
                <div className="text-xs text-foreground-500 mt-1">深耕吃瓜</div>
              </div>
              <div className="text-center">
                <div className="text-[28px] font-heading text-accent-600">500w+</div>
                <div className="text-xs text-foreground-500 mt-1">忠实用户</div>
              </div>
              <div className="text-center">
                <div className="text-[28px] font-heading text-primary-600">10w+</div>
                <div className="text-xs text-foreground-500 mt-1">原创内容</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}